export const MEDIA_SRC_ATTRS = [
  ['img', 'src'],
  ['source', 'src'],
  ['video', 'src'],
  ['audio', 'src'],
  ['track', 'src'],
  ['embed', 'src'],
  ['input', 'src'],
  ['video', 'poster'],
  ['audio', 'poster'],
  ['object', 'data'],
];
